"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LogoLinkContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _footerControls = require("./footer-controls.js");
var _image = require("@site/pattern-library-core/image");
/* eslint-disable max-len */

const LogoLinkContainer = exports.LogoLinkContainer = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "LogoLinkContainer",
  class: "pl-l2f37ib"
});
const LogoImage = /*#__PURE__*/(0, _react2.styled)(_image.LazyImage)({
  name: "LogoImage",
  class: "pl-l62aet2"
});

/**
 * Footer Controls component.
 * @returns {React.ReactElement} Logo Link
 * @public
 */
function LogoLink({
  href = '/',
  privateLabelId = 1,
  logoImage,
  ariaLabel = 'GoDaddy Home Page'
}) {
  const hardcodedBrands = _patternLibraryUtils.plidMap.GoDaddy === privateLabelId || _patternLibraryUtils.plidMap['123 Reg'] === privateLabelId;
  return /*#__PURE__*/_react.default.createElement(LogoLinkContainer, {
    href: href,
    "aria-label": ariaLabel,
    "data-track-name": "logo",
    "data-track-eid-click": true,
    "data-cy": "logo-link"
  }, hardcodedBrands ? _patternLibraryUtils.FooterSVGLogos[privateLabelId] : /*#__PURE__*/_react.default.createElement(LogoImage, logoImage));
}
LogoLink.propTypes = {
  href: _propTypes.default.string,
  privateLabelId: _propTypes.default.number,
  ariaLabel: _propTypes.default.string,
  logoImage: _propTypes.default.shape({
    height: _propTypes.default.number,
    width: _propTypes.default.number,
    altText: _propTypes.default.string,
    url: _propTypes.default.string
  })
};
var _default = exports.default = LogoLink;